import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type GroupProps = PropsWithChildren<{
    className?: string;
}>

export const Group = ({className, children}: GroupProps) => {
    return (
        <div className={twMerge("mb-3", className)}>
            {children}
        </div>
    )
}
